const storageKey = 'token';

// In-memory copy of the portal session token; this is the source of truth for the page.
// localStorage is only used to restore the session after a reload. It can throw (storage blocked),
// be cleared by the browser, or be changed by another tab, so it is never read again once loaded.
// `undefined` means not loaded from localStorage yet.
let memoryToken: string | null | undefined;

export function getAuthToken(): string | null {
    if (memoryToken === undefined) {
        try {
            memoryToken = localStorage.getItem(storageKey);
        } catch {
            memoryToken = null;
        }
    }
    return memoryToken;
}

export function setAuthToken(token: string) {
    memoryToken = token;
    try {
        localStorage.setItem(storageKey, token);
    } catch {
        // The in-memory token still works for this page; only restoring after a reload is lost
    }
}

export function clearAuthToken() {
    memoryToken = null;
    try {
        localStorage.removeItem(storageKey);
    } catch {
        // Nothing to clean up if storage is unavailable
    }
}
